import React, { Component, useState } from 'react';
import ReactDOM from "react-dom";
import { Icon, Button, Modal } from 'semantic-ui-react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import './styles.css';
import CarouselTitle from './CarouselTitle';

export default class ModalCarrosseisOrdenation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            portal: {}
        }    
    }

    componentWillMount() {
        //Portal para que o Drag N Drop não fique bugado no Modal
        const portal = document.createElement("div");
        portal.classList.add("my-super-portal");
        document.body.appendChild(portal);

        this.setState({ portal });
    }

    handleOptionDragEnd = (result) => {
        if(!result.destination) return;
        
        const { carrosseis } = this.props;
        const options = carrosseis.options;
        const { source, destination } = result;
        const [removed] = options.splice(source.index, 1);

        options.splice(destination.index, 0, removed);
        
        options.map((option, index) => {
            option.value.ordem = index+1
        });

        carrosseis.options = options;
        
        this.setState({ carrosseis });
    }

    carouselTitle = (provided, snapshot, option) => {
        const child = (
            <CarouselTitle 
                provided = { provided }
                snapshot = { snapshot }
                option = { option }
            />
        );        

        //Portal para que o Drag N Drop não fique bugado aqui no Modal

        const usePortal = snapshot.isDragging;
        
        if (!usePortal) {
            return child;
        }

        return ReactDOM.createPortal(child, this.state.portal);
    }

    render(){
        const { carrosseis } = this.props;
        
        return(
            <Modal trigger={
                <Button id="painel-carrosseis_reordenar-carrosseis" primary>
                    <Icon name="ordered list" /> Reordenar
                </Button>
            }>
                <Modal.Header>Reordenar carrosseis</Modal.Header>
                <Modal.Content>                 
                    <DragDropContext onDragEnd = { result => this.handleOptionDragEnd(result)}>
                        <Droppable droppableId={'column2'} key={'column2'} direction='vertical'>
                            {(provided, snapshot) => {
                                return (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        id="painel-carrosseis_area-ordenar-carrosseis"
                                    >
                                            {carrosseis.options.map((option,index) => {
                                            return (
                                                <Draggable key={option.key.toString()} draggableId={option.key.toString()} index={index}>
                                                    {(provided, snapshot) => this.carouselTitle(provided, snapshot, option) }
                                                </Draggable>
                                            );
                                        })}
                                        {provided.placeholder}
                                    </div>
                                );
                            }}
                        </Droppable>
                    </DragDropContext>
                </Modal.Content>
            </Modal>
        );
    }
}